__turbopack_context__.v({
  "average": "ProductRating-module-scss-module__wFfTMa__average",
  "button": "ProductRating-module-scss-module__wFfTMa__button",
  "emptyReviews": "ProductRating-module-scss-module__wFfTMa__emptyReviews",
  "emptyReviewsText": "ProductRating-module-scss-module__wFfTMa__emptyReviewsText",
  "ratingValue": "ProductRating-module-scss-module__wFfTMa__ratingValue",
  "reviews": "ProductRating-module-scss-module__wFfTMa__reviews",
  "reviewsUnderlined": "ProductRating-module-scss-module__wFfTMa__reviewsUnderlined",
  "root": "ProductRating-module-scss-module__wFfTMa__root",
});
